import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { Tab } from './parts';
import * as style from './style.css';
import { ITabItem } from '../../containers/Tabs/utils/types';
import { EPageType } from '../../types/page/pageType';

interface ITabsProps {
  tabs: ITabItem[];
  pageType: EPageType;
  onChange: (val: EPageType) => void;
}

export const Tabs: React.FC<ITabsProps> = ({ tabs, pageType, onChange }) => {
  return (
    <div className={style['container']}>
      <div className={style['title']}>
        <UIHeading1>Онлайн-договор — это удобно для всех</UIHeading1>
      </div>
      <div className={style['tabs']}>
        {tabs.map(({ value, label, img }, index) => (
          <Tab
            key={label + index}
            value={value}
            pageType={pageType}
            label={label}
            img={img}
            onChange={() => onChange(value)}
          />
        ))}
      </div>
    </div>
  );
};
